<template>
  <div class="wrapper">
    <div class="text">
      <p>{{ $t("pages.integrations.text") }}</p>
    </div>
    <div class="integrations">
      <div class="integrations-column">
        <h4>{{ $t("pages.integrations.subtitle1") }}</h4>
        <img class="integration-img" src="@/assets/pages/integrations/knx.png" alt="knx" />
        <img class="integration-img" src="@/assets/pages/integrations/loxone.png" alt="loxone" />
        <img class="integration-img" src="@/assets/pages/integrations/gira.png" alt="gira" />
        <p class="and-more">And more...</p>
      </div>
      <div class="integrations-column">
        <h4>{{ $t("pages.integrations.subtitle2") }}</h4>
        <img class="integration-img" src="@/assets/pages/integrations/airplay-devices.svg" alt="Airplay" />
        <img class="integration-img" src="@/assets/pages/integrations/integrations-pair-1.png" alt="Integrations pair" />
        <img class="integration-img" src="@/assets/pages/integrations/integrations-pair-2.png" alt="Integrations pair" />
        <p class="and-more">{{ $t("pages.integrations.andMore") }}</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Integrations",
  components: {},
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

.wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

}
.text {
  flex: 1 1 0px;
  margin: 0 20px;
}
.integrations {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex: 2 1 0px;

  .integrations-column {
    margin: 0 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .integration-img {
    max-width: 100%;
    max-height: 150px;
    margin: 10px 0;
  }

  .and-more {
    font-size: 15px;
    text-align: center;
    margin-top: 20px;
  }
}

@media only screen and (max-width: $screen-xs) {
  .wrapper {
    margin-top: 40px;
    flex-direction: column;
    .integrations {
      flex-direction: column;
      .integrations-column {
        margin-bottom: 40px;
      }
      .integration-img {
        max-height: 100px;
      }
    }
  }
  .text {
    margin: 0;
  }
}
</style>
